/** Copyright �2013 Renoworks, Inc. All rights reserved. www.Renoworks.com
 *
 * @param {jQuery} $ A reference to the jQuery object.
 */
(function ($) {
  Renoworks = window.Renoworks || {};
  Renoworks.ProjectHandler = new ProjectHandler();

  var isMasking = false;

  function ProjectHandler() {}

  /**
     * Populate projects into their appropriate containers
     *
     * @param {boolean} loadSamples - Whether to load the sample projects, called at app load
     * @param {String} container - String pointing to the container to populate. Used only for uploads, if left blank will populate both containers (select scene and my account)
     */
  ProjectHandler.prototype.populateProjects = function (loadSamples, container) {
    var projects;
    // Samples
    if (loadSamples) {
      projects = Renoworks.ProjectController.getProjects();
      container = '#select_scene .samples .paginator, #samples_mobile';
      $(container).html('');
      for (var i = 0; i < projects.length; i++) {
        Renoworks.ProjectHandler.addScene(projects[i], 'sample_project', container);
      }

      // Get the parents static width and calculate what our width will end up as
      var parentWidth = parseInt($('#select_scene').css('width')) - 120; // 120 padding
      var width = parentWidth * 0.6667; // 66.67% width,

      $('#select_scene .samples .paginator').pagination({
        controls: '.pagination_controls',
        paginator: '.counter',
        perPage: 4,
        width: width,
        animationSpeed: 200,
      });
    }
  };

  /**
     * Toggle design mode for the project
     * Hides/Shows the Raphael for drawing
     *
     * @param {boolean}
     */
  ProjectHandler.prototype.setProjectDesignMode = function (designMode) {
    if (designMode) {
      $('.raphael').hide();
      Renoworks.MaskingController.eraseRasterCanvas();
    } else {
      $('.raphael').show();
    }
  };

  /**
     * Sets the current masking state
     *
     * @param {boolean}
     */
  ProjectHandler.prototype.setIsMasking = function (masking) {
    isMasking = masking;
  };

  /**
     * Returns if we are currently masking
     */
  ProjectHandler.prototype.isMasking = function () {
    return isMasking;
  };

  ProjectHandler.prototype.projectImageClickHandler = function (e, selector) {
    if (!Renoworks.MaskingController.getPanning()) {
      // e.stopPropagation();
      var scale = Renoworks.MaskingController.getScale();
      var offset = selector.find('.project_canvas').offset();
      var x = Math.round(((e.pageX - offset.left) / scale));
      var y = Math.round(((e.pageY - offset.top) / scale));
      var layers = Renoworks.ProjectController.getLayers();
      var gutter = Renoworks.MaskingController.getGutter();
      for (var i = 0; i < layers.length; i++) {
        var p;
        var point = { x: x - gutter, y: y - gutter };

        if (layers[i].perspective.pointInside(point)) { // if the click is within the polygon
          // Set the layer as selected
          Renoworks.LayerHandler.setSelectedLayer(layers[i]);
          break;
        }
      }
    }
  };

  ProjectHandler.prototype.projectHoverHandler = function (e, selector) {
    if (Renoworks.mobile) {
      return;
    }
    if (!Renoworks.MaskingController.getPanning()) {
      var scale = Renoworks.MaskingController.getScale();
      var offset = selector.find('.project_canvas').offset();
      var x = Math.round(((e.pageX - offset.left) / scale));
      var y = Math.round(((e.pageY - offset.top) / scale));
      var layers = Renoworks.ProjectController.getLayers();
      var gutter = Renoworks.MaskingController.getGutter();
      for (var i = 0; i < layers.length; i++) {
        var p;
        var point = { x: x - gutter, y: y - gutter };

        var productApplied = Renoworks.ProjectController.getProductForRegion(layers[i].name);

        if (layers[i].perspective.pointInside(point) || Renoworks.ProjectHandler.isMasking()) { // if the mouse is within the polygon
          // Set the layer as selected
          layers[i].perspective.dontFill = false;
        } else if (productApplied) {
          layers[i].perspective.dontFill = true;
        }
      }
      Renoworks.LayerHandler.showLayerHighlights();
    }
  };

  ProjectHandler.prototype.projectChangedEventHandler = function () {
    // Clear the preview canvases when the project has changed
    Renoworks.ProjectController.clearSelectedProduct();
    Renoworks.ProjectController.setRegion('');
    Renoworks.ViewController.dontSave = false;
    $('.project_image .masking_button').remove();

    var tag = Renoworks.ProjectController.getTag();
    Renoworks.LayerHandler.loadLayerRegions();

    if (Renoworks.MaskingController.isMasking()) {
      Renoworks.MaskingController.cancel();
    }

    Renoworks.MaskingController.start(true);
    if (tag === 'uploaded') {
      Renoworks.ViewController.showModal('prepare_photo');
      Renoworks.ProjectHandler.setProjectDesignMode(false);
      Renoworks.LayerHandler.showMaskingButtons();
    } else {
      Renoworks.ViewController.showModal('select_product');

      Renoworks.ProjectHandler.setProjectDesignMode(true);
      Renoworks.MaskingController.disableDrawing();
      if (Renoworks.ViewController.isUrlProduct()) {
        Renoworks.ViewController.applyUrlProduct();
      }

      Renoworks.ProductHandler.showFirstTab();

      setProductFilter(Renoworks.ProjectController.getCurrentProject());
      Renoworks.ProductHandler.resetDoorProperties();
    }

    $('.project_image').show();
    $('.project_image').attr('top_pos', null);
    $('.project_image').attr('left_pos', null);
    Renoworks.ViewController.enableDisableTabs();

    $('#door_only .door_image').remove();
  };

  function setProductFilter(project) {
    var single = false,
      double = false;
    for (var i = 0; i < project.layers.length; i++) {
      var layer = project.layers[i];
      if (layer.productFilter) {
        if (layer.productFilter.indexOf('Single') != -1) {
          single = true;
        } else if (layer.productFilter.indexOf('Double') != -1) {
          double = true;
        }
      }
    }
    if (single) {
      if (double) {
        Renoworks.ProductHandler.filter = 'both';
      } else {
        Renoworks.ProductHandler.filter = 'single';
      }
    } else if (double) {
      Renoworks.ProductHandler.filter = 'double';
    }
  }

  ProjectHandler.prototype.projectImageChangedEventHandler = function (e) {
    $('#loading').hide();
    $('#product_preview_rendering').hide();
    var url = e.path;
    Renoworks.ProjectHandler.changeProjectImage(url, null, true); // don't fade so the eye icons dont flicker
  };

  ProjectHandler.prototype.changeProjectImage = function (url, callbacks, dont_fade) {
    // Create a new div that fades in with the new project image
    // When the new image is faded in, change the background image of the original project image
    // and delete the newly created div
    var projectImage = $('.project_image');

    var tempImage = $('<div class="project_image_temp" />');

    tempImage.hide();
    tempImage.insertAfter(projectImage);

    // Pre-load image so that it's ready to be displayed
    var img = $('<img width="100"/>').css('visibility', 'hidden').attr('src', url).load(function () {
      if (dont_fade) {
        projectImage.removeClass('first');
        projectImage.removeAttr('first');

        projectImage.css('background-image', 'url(\'' + url + '\')');
      } else {
        var ratio = img.width() / img.height();
        tempImage.attr('ratio', ratio);
        // Set the background values for tempImage
        tempImage.css('background-image', 'url(\'' + url + '\')')
          .css('background-size', projectImage.css('background-size'))
          .css('background-position', projectImage.css('background-position'));

        tempImage.fadeIn(Renoworks.ViewController.FADE_SPEED, function () {
          projectImage.removeClass('first');
          projectImage.removeAttr('first');

          projectImage.css('background-image', 'url(\'' + url + '\')');
          if (url.indexOf('master.jpg') != -1) {
            Renoworks.ProjectHandler.setBackgroundSize('cover');
          }
          // Remove the tempImage
          tempImage.remove();
        });
      }
      // Set preview images
      $('#product_preview .product_preview_image').css('background-image', 'url(\'' + url + '\')');
      img.remove();

      Renoworks.LayerHandler.showLayerHighlights();

      if (callbacks) {
        for (var i = 0; i < callbacks.length; i++) {
          callbacks[i].func.apply(null, callbacks[i].args);
        }
      }
    });

    $('body').append(img);
  };

  ProjectHandler.prototype.loadSavedDesign = function (selector) {
    if (Renoworks.MaskingController.isMasking()) {
      Renoworks.MaskingController.cancel(false);
    }

    var design = Renoworks.User.getDesign(selector.attr('data-label'));

    if (design) {
      Renoworks.ViewController.closeModal('select_scene');

      // Set project
      var projects;
      if (design.tag == 'sample') {
        projects = Renoworks.ProjectController.getProjects();
      } else {
        projects = Renoworks.ProjectController.getUploads();
      }
      var cp;
      for (var i = 0; i < projects.length; i++) {
        if (projects[i].folder == design.folder) {
          cp = projects[i];
          break;
        }
      }
      if (cp) {
        if (!cp.loaded) {
          $(cp).one('loaded', function () {
            finishLoadingProject(cp, design);
          });
          cp.load();
        } else {
          finishLoadingProject(cp, design);
        }
      }
    }
  };

  function finishLoadingProject(cp, design) {
    var rwd,
      gridSettings,
      collection,
      style;

    // Set project
    Renoworks.ProjectController.setCurrentProject(cp);
    Renoworks.MaskingController.setDesignMode(true);
    Renoworks.ProjectHandler.setProjectDesignMode(true);
    Renoworks.ViewController.changeProject(cp);
    // Show the collections tab, so that we can select from it
    Renoworks.ProductHandler.showFirstTab();

    Renoworks.LayerHandler.loadLayerRegions();
    Renoworks.MaskingController.start(true);

    // Set product on project
    if (design.palette) {
      var once = true;
      for (var key in design.palette) {
        if (design.palette.hasOwnProperty(key)) {
          var product = design.palette[key];
          var data = product.data;

          var str = data.split('||');
          for (var i = 0; i < str.length; i++) {
            var kv = str[i].split('=');
            var key2 = kv[0];
            var value = kv[1];

            if (key2 == 'rwd') {
              rwd = value;
            } else if (key2 == 'gridSettings') {
              gridSettings = value;
            } else if (key2 == 'Collection') {
              collection = value;
            } else if (key2 == 'Style') {
              style = value;
            }
          }

          Renoworks.ProjectController.setProductForRegion('rwd=' + rwd + '||gridSettings=' + gridSettings, 'grid', key);
          if (once) {
            once = false;
            Renoworks.ProductHandler.setProductForDesign(collection, style, gridSettings);
            $('#sub_header_menu li[data-label="Collection"]').click(); // Open up collection as the "default" tab
          }
        }
      }
    }

    $('.project_image .masking_button').remove();

    Renoworks.LayerHandler.showDoorOnlyView();

    if (!Renoworks.mobile) {
      Renoworks.ViewController.showModal('select_product');
    }

    Renoworks.ProjectHandler.setProjectDesignMode(true);
    Renoworks.MaskingController.disableDrawing();
    if (Renoworks.ViewController.isUrlProduct()) {
      Renoworks.ViewController.applyUrlProduct();
    }

    setProductFilter(Renoworks.ProjectController.getCurrentProject());
    Renoworks.ProductHandler.resetDoorProperties();

    $('.project_image').show();
    $('.project_image').attr('top_pos', null);
    $('.project_image').attr('left_pos', null);
    Renoworks.ViewController.enableDisableTabs();

    $('#door_only .door_image').remove();

    // Render
    Renoworks.ProjectController.render();
    Renoworks.ProductHandler.renderProduct();
  }

  ProjectHandler.prototype.projectSavedEventHandler = function (e) {
    Renoworks.ViewController.dontSave = false;
    if (Renoworks.MaskingController.isMasking()) {
      $(Renoworks.Event).trigger({ type: Renoworks.Event.UPLOADS_UPDATED });
      var html = '<p align="center" class="locale_html" data-locale-id="k_proj_saved">' + Renoworks.LocaleController.getValueForKey('k_proj_saved') + '</p>';
      var title = Renoworks.LocaleController.getValueForKey('succ');
      var classes = 'success';
      var buttons = [];
      var button = new Renoworks.Button();
      button.name = Renoworks.LocaleController.getValueForKey('close');
      button.classes = 'btn';
      button.callback = function () {
        $('.dialog_close:first').trigger('click');
      };
      buttons.push(button);

      Renoworks.Notify.show(html, title, classes, buttons);
    }

    if (Renoworks.User.loggedIn) {
      // Save upload to account
      if (!Renoworks.ProjectController.isSaved()) {
        var folder = (e.folder) ? e.folder : Renoworks.ProjectController.getFolder();
        Renoworks.User.saveUpload(folder, true);
      }
    }
  };

  ProjectHandler.prototype.saveDesignSuccessEventHandler = function () {
    var html = '<p align="center" class="locale_html" data-locale-id="design_save">' + Renoworks.LocaleController.getValueForKey('design_save') + '</p>';
    var title = Renoworks.LocaleController.getValueForKey('succ');
    var classes = 'success';
    var buttons = [];
    var button = new Renoworks.Button();
    button.name = Renoworks.LocaleController.getValueForKey('close');
    button.classes = 'btn';
    button.callback = function () {
      Renoworks.Notify.hide();
      $('.button_modal[data-label="review_doors"]').click();
    };
    buttons.push(button);

    Renoworks.Notify.show(html, title, classes, buttons);
  };

  ProjectHandler.prototype.addScene = function (project, type, container) {
    if (!type) {
      type = 'sample_project';
    }
    if (!container) {
      if (type == 'sample_project') {
        container = '#select_scene .samples .paginator';
      } else if (type == 'saved_upload') {
        // TODO: Update the second part of this selector when the account story is finished
        container = '#select_scene .my_projects .paginator, #account_uploads .paginator';
      } else if (type == '') {
        container = '#account_designs .paginator';
      }
    }

    type = '.' + type;

    var html = $(type).first().wrap('<p/>').parent()
      .html();
    $(type).first().unwrap();

    html = html.replace(new RegExp('#PROJECT_NAME#', 'g'), project.name);
    var image = project.tag + '/' + project.folder + '/sample.jpg';
    if (type == '.saved_design') {
      image = project.render;
    }
    html = html.replace(new RegExp('#PROJECT_IMAGE#', 'g'), 'data/' + Renoworks.client + '/projects/' + image);

    var div = $(html);

    // If the project name is too large, shrink the text
    if (project.name && project.name.length > 34) {
      div.find('.footer').css('font-size', '16pt');
    }
    div.show();
    if (type == '.sample_project') {
      if (Renoworks.LocaleController.getLocale() == 'en') {
        div.find('label').html(project.name);
      } else if (Renoworks.LocaleController.getLocale() == 'fr') {
        div.find('label').html(project.name_fr);
      }
      div.attr('data-label', project.tag + '/' + project.folder);
      $(container).append(div);
      if (project.layers.length != 0) { // some uploads are marked as sample projects, so check if they are masked
        div.find('.not_masked').show();
        div.click(':not(i)', function (e) {
          Renoworks.ProjectController.setProject($(this).attr('data-label'));
          Renoworks.MaskingController.start(true);
        });
      } else {
        div.find('.not_masked').hide();
      }
    } else if (type == '.saved_design') {
      div.attr('data-label', project.id);
      $(container).append(div);
    } else if (type == '.saved_upload') {
      if (!project.masked && Renoworks.mobile) {
        div.addClass('nomasking');
      }
      div.attr('data-label', project.id);
      // div.addClass('no_scale');
      $(container).append(div);
    }

    return div;
  };

  ProjectHandler.prototype.saveDesignClicked = function () {
    if (Renoworks.User.loggedIn) {
      // Save upload to account
      if (!Renoworks.ProjectController.isSaved()) {
        Renoworks.User.saveUpload(Renoworks.ProjectController.getFolder(), true);
      }
    }
    doSaveDesign();
  };

  ProjectHandler.prototype.deleteSavedDesignFromAccount = function (e, selector) {
    e.stopPropagation();
    var id = selector.closest('.saved_design').attr('data-label');
    var html = '<p align="center" class="locale_html" data-locale-id="del_design">' + Renoworks.LocaleController.getValueForKey('del_design') + '</p>';
    var title = Renoworks.LocaleController.getValueForKey('confirm');
    var classes = 'notice';
    var buttons = [];
    var button = new Renoworks.Button();
    button.name = Renoworks.LocaleController.getValueForKey('yes');
    button.classes = 'btn';
    button.callback = function () {
      Renoworks.User.deleteDesign(id);
      Renoworks.Notify.hide();
    };
    buttons.push(button);
    button = new Renoworks.Button();
    button.name = Renoworks.LocaleController.getValueForKey('no');
    button.classes = 'btn';
    button.callback = function () {
      Renoworks.Notify.hide();
    };
    buttons.push(button);

    Renoworks.Notify.show(html, title, classes, buttons);
  };

  ProjectHandler.prototype.deleteSavedUploadFromAccount = function (e, selector) {
    e.stopPropagation();
    var id = selector.closest('.saved_upload').attr('data-label');

    var html = '<p align="center" class="locale_html" data-locale-id="del_proj_des">' + Renoworks.LocaleController.getValueForKey('del_proj_des') + '</p>';
    var title = Renoworks.LocaleController.getValueForKey('confirm');
    var classes = 'notice';
    var buttons = [];
    var button = new Renoworks.Button();
    button.name = Renoworks.LocaleController.getValueForKey('yes');
    button.classes = 'btn';
    button.callback = function () {
      Renoworks.User.deleteUpload(id);
      Renoworks.Notify.hide();
    };
    buttons.push(button);
    button = new Renoworks.Button();
    button.name = Renoworks.LocaleController.getValueForKey('no');
    button.classes = 'btn';
    button.callback = function () {
      Renoworks.Notify.hide();
    };
    buttons.push(button);

    Renoworks.Notify.show(html, title, classes, buttons);
  };

  ProjectHandler.prototype.loadMyProjects = function () {
    var uploads = Renoworks.ProjectController.getUploads();
    var designs = Renoworks.User.getDesigns();
    var container = '#select_scene .my_projects .paginator, #my_projects_mobile';

    $(container).empty();
    if (uploads.length === 0 && designs.length === 0) {
      $(container).parent().find('.pagination_controls').hide();
      $(container).parent().find('.no_projects').show();
    } else {
      $(container).parent().find('.pagination_controls').show();
      $(container).parent().find('.no_projects').hide();

      designs.forEach(function (design) {
        Renoworks.ProjectHandler.addScene(design, 'saved_design', container);
      });
      uploads.forEach(function (upload) {
        Renoworks.ProjectHandler.addScene(upload, 'saved_upload', container);
      });

      // Get the parents static width and calculate what our width will end up as
      var parentWidth = parseInt($('#select_scene').css('width'));
      var width = parentWidth * 0.3333 - 80; // 33% width, 40 padding each side

      $('#select_scene .my_projects .paginator').pagination({
        controls: '.pagination_controls',
        paginator: '.counter',
        perPage: 2,
        width: width,
        animationSpeed: 200,
      });
    }
  };

  /**
     * Sets the background-size and background-position to appropriate px values representing contain or cover
     * Takes into account the header and sidebar and positions relative to those rather than the full window (The values set to top and left will need to be adjusted if the site layout changes; separately for both landscape and portrait)
     *
     * ****NOTE**** If masking for mobile on responsive sites is implemented this code causes the mask canvas to be misaligned from the background image.
     *      The masking_controller currently does not have the ability to move the canvas separately from the background-image
     *
     * @param {string} size: 'cover' or 'contain'
     */
  ProjectHandler.prototype.setBackgroundSize = function (size, noSidebar) {
    var buttonDiv = $('#resize_background_button');
    var orientation = Renoworks.ViewController.getOrientation();
    if (!orientation) { // if orientation is not set it means it is not mobile so do nothing
      return;
    }

    var image_url = $('.project_image').css('background-image').replace('url', '').replace(/[\"\(\)]/g, '');
    image = new Image();

    // just in case it is not already loaded
    $(image).load(function () {
      var bgImgWidth = image.width;
      var bgImgHeight = image.height;
      var bgRatio = bgImgWidth / bgImgHeight; // A value > 1 means the image is landscape orientated

      var newHeight,
        newWidth,
        left,
        top,
        centeredLeft,
        centeredTop,
        maxWidth,
        maxHeight,
        backPos,
        bSize;

      if (size == 'contain') {
        buttonDiv.find('i').removeClass('contain').addClass('cover');
        buttonDiv.find('i').removeClass('fa-compress').addClass('fa-expand');

        if (orientation == 'landscape') {
          if (!noSidebar) {
            left = $('#layer_selection').width();
            maxWidth = $(window).width() - $('#layer_selection').width();
          } else {
            left = 0;
            maxWidth = $(window).width();
          }
          top = $('header').height();

          maxHeight = $(window).height() - $('header').height();

          if (bgRatio > 1) { // landscape image
            newWidth = maxWidth;
            newHeight = newWidth / bgRatio;

            if (newHeight < maxHeight) { // The height of the image isn't too big
              bSize = newWidth + 'px ' + newHeight + 'px';
              centeredTop = (maxHeight - newHeight) / 2 + top;
              backPos = left + 'px ' + centeredTop + 'px';
            } else {
              newWidth = bgRatio * maxHeight;
              newHeight = maxHeight;
              bSize = newWidth + 'px ' + newHeight + 'px';
              centeredLeft = (maxWidth - newWidth) / 2 + left;
              backPos = centeredLeft + 'px ' + top + 'px';
            }
          } else { // portrait image
            newHeight = maxHeight;
            newWidth = newHeight * bgRatio;

            bSize = newWidth + 'px ' + newHeight + 'px';
            centeredLeft = (maxWidth - newWidth) / 2 + left;
            backPos = centeredLeft + 'px ' + top + 'px';
          }
        } else if (orientation == 'portrait') {
          left = '0';
          top = $('#layer_selection').height() + $('header').height();

          maxHeight = $(window).height() - $('header').height() - $('#layer_selection').height() - $('#utilities').height();
          maxWidth = $(window).width();

          if (bgRatio > 1) { // landscape image
            newWidth = maxWidth;
            newHeight = newWidth / bgRatio;

            bSize = newWidth + 'px ' + newHeight + 'px';
            backPos = left + 'px ' + top + 'px';
          } else {
            newHeight = maxHeight;
            newWidth = maxHeight * bgRatio;

            if (newWidth > maxWidth) {
              newWidth = maxWidth;
              newHeight = newWidth / bgRatio;

              bSize = newWidth + 'px ' + newHeight + 'px';
              centeredLeft = (maxWidth - newWidth) / 2;
              backPos = centeredLeft + 'px ' + top + 'px';
            }
          }
        }

        if (!Renoworks.mobile) {
          buttonDiv.tooltip('option', 'content', 'Expand Preview'); // Use this instead of changing the title attribute so that the custom tooltip changes correctly
        }
        $('.project_image').css('cursor', 'default');
      } else if (size == 'cover') {
        buttonDiv.find('i').removeClass('cover').addClass('contain');
        buttonDiv.find('i').removeClass('fa-expand').addClass('fa-compress');
        if (!Renoworks.mobile) {
          buttonDiv.tooltip('option', 'content', 'Contain Preview');// Use this instead of changing the title attribute so that the custom tooltip changes correctly
        }

        if (orientation == 'landscape') {
          if (!noSidebar) {
            left = $('#layer_selection').width();
            maxWidth = $(window).width() - $('#layer_selection').width();
          } else {
            left = 0;
            maxWidth = $(window).width();
          }
          top = $('header').height();

          maxHeight = $(window).height() - $('header').height();

          if (bgRatio > 1) { // landscape image
            newHeight = maxHeight;
            newWidth = newHeight * bgRatio;

            bSize = newWidth + 'px ' + newHeight + 'px';
            centeredLeft = (maxWidth - newWidth) / 2 + left;
            backPos = centeredLeft + 'px ' + top + 'px';
          } else { // portrait image
            newWidth = maxWidth;
            newHeight = newWidth / bgRatio;

            bSize = newWidth + 'px ' + newHeight + 'px';
            centeredTop = (maxWidth - newWidth) / 2 + top;
            backPos = left + 'px ' + centeredTop + 'px';
          }
        } else if (orientation == 'portrait') {
          left = '0';
          top = $('#layer_selection').height() + $('header').height();

          maxHeight = $(window).height() - $('header').height() - $('#layer_selection').height() - $('#utilities').height();
          maxWidth = $(window).width();

          if (bgRatio > 1) { // landscape image
            newHeight = maxHeight;
            newWidth = newHeight * bgRatio;

            bSize = newWidth + 'px ' + newHeight + 'px';
            centeredLeft = (maxWidth - newWidth) / 2 + left;
            backPos = centeredLeft + 'px ' + top + 'px';
          } else {
            newWidth = maxWidth;
            newHeight = newWidth / bgRatio;

            bSize = newWidth + 'px ' + newHeight + 'px';
            centeredTop = (maxWidth - newWidth) / 2 + top;
            backPos = left + 'px ' + centeredTop + 'px';
          }
        }
      }

      $('.project_image').css({
        'background-size': bSize,
        'background-position': backPos,
      });
    });

    image.src = image_url;

    buttonDiv.show();
  };

  ProjectHandler.prototype.sampleProjectClick = function (e) {
    if (Renoworks.ProjectController.getTag() == 'sample') {
      $('#loading').show();
    }
    // $("#design_report_button").show();
  };

  function extractUrl(url) {
    if (url) { return url.replace(/"/g, '').replace(/url\(|\)$/ig, ''); }
  }

  function doSaveDesign(no_trigger) {
    var name = $('form[name="save_project"] input[name="save_project_name"]').val();
    var user = Renoworks.User;
    var design = Renoworks.ProjectController.createDesign();

    if (!name || name == 'Untitled' || name == 'Entrez un nom') { // TODO: This should check the locale and check based on the current locale.
      var date = new Date();
      name = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes();
    } else {
      name = name.encodeXML();
    }
    if (design) {
      design.name = name;

      // Convert design to xml
      var xml = '<design name="' + name + '" tag="' + design.tag + '" folder="' + design.folder + '">';

      var palette = design.palette;
      var keys = [];
      for (var key in palette) {
        if (palette.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] != null && keys[i] != 'name') // save if not null
        {
          if (palette[keys[i]] != null) // save if not null
          {
            if (palette[keys[i]].data) {
              xml += '<area name="' + keys[i] + '" data="' + palette[keys[i]].data.encodeXML()
                            + '" type="' + palette[keys[i]].type + '" />';

              // if(image != 'none'){
              //  var url = extractUrl(image);
              //  xml += 'renderedImage="' + url.substring(url.indexOf('data'), url.length) + '" ';
              // }

              /* xml += '/>'; */
            }
          }
        }
      }

      xml += '</design>';

      // Check User object for childId, so that we can save a design to a child user account. API requires logged in user to be parent of account trying to save to. Created for CAP - DB 18/01/2016
      var childId = Renoworks.User.childId;
      $.ajax({
        type: 'POST',
        url: 'Account',
        data: {
          request: 'saveDesign',
          data: xml,
          render: design.tag + '/' + design.folder + '/images/' + design.render + '.jpg',
          site: Renoworks.client,
          userId: childId,
        },
        dataType: 'text',
        success: function (data) {
          if (data.indexOf('ERROR') != -1) {
            alert(data);
          } else {
            if (!no_trigger) { // used in cap so when capturing design the popup wont show up
              $(Renoworks.Event).trigger(Renoworks.Event.SAVE_DESIGN_SUCCESS);
            }
            user.loadDesigns();
          }
        },
        error: function (request, status, error) {
          Renoworks.ViewController.alert(request.statusText);
        },
      });
    } else {
      $(Renoworks.Event).trigger(Renoworks.Event.PALETTE_SAVE_FAILED);
    }
    $('.modal').click();
  }

  function setRightSidebar(projectTag) {
    if (projectTag == 'sample') {
      // hide the scale button
      $('#scale_button').hide();
      $('#scale_options').hide();

      // make the project name uneditable
      $('#project_name').attr('readonly', 'readonly');

      // hide the add layer button
      $('#layer_selection .add_layers').hide();

      /* // Hide save project
            $('.save_project_bar').hide(); */

      // Show save project
      $('.save_project_bar').hide();
    } else if (projectTag == 'uploaded') {
      // show the scale button
      $('#scale_button').show();

      // make the project name editable
      $('#project_name').removeAttr('readonly');

      // show the add layer button
      $('#layer_selection .add_layers').show();
      // Renoworks.LayerHandler.openScaleSettings(); // open scale settings on an uploaded photo

      $('body').trigger('closeScale'); // dont show scale settings if opening a saved upload
      // Show save project
      $('.save_project_bar').show();
    }
  }
}(jQuery));
